<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>后台管理</el-breadcrumb-item>
      <el-breadcrumb-item>四级导航栏管理</el-breadcrumb-item>
    </el-breadcrumb>
     <el-card>
      <el-row>
  <el-col :span="6">
      <div>
    <el-select v-model="treeDate" placeholder="上级菜单">
      <el-option label="全部" value="" ></el-option>
      <el-option :label="info.info_NAME" :value="info.info_ID" v-for="(info,index) in InfoList" :key="index"></el-option>
    </el-select>
    <el-button slot="append" icon="el-icon-search" @click="getFourNav"></el-button>
</div>
</el-col>
<el-col :span="5">
  <el-button type="primary" @click="showNavigation('1')">添加四级导航栏</el-button> </el-col>         
 
  <el-col :span="3"> <p class="lableforSearch">查询到{{menusList.length}}条数据</p></el-col>
  </el-row>
        <el-table
      :data="menusList"
      border
      style="width: 100%">
      <el-table-column
        prop="infoFourId"
        label="ID"
        width="100">
      </el-table-column>
      <el-table-column
        prop="infoFour_NAME"
        label="姓名"
        show-overflow-tooltip
        width="130">
      </el-table-column>
      <el-table-column
        width="180"
        prop="createFour_DATA"
        label="创建时间">
      </el-table-column>
          <el-table-column
        width="180"
        prop="htmlPath_Four"
        show-overflow-tooltip
        label="html状态">
      </el-table-column>
           <el-table-column
        label="操作"
        width="280">
          <template slot-scope="scope" >
  <el-button  @click="deleteMenus(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
  <!-- <el-button  icon="el-icon-aim" size="small" @click="showExcelByHeadId(scope.row)"></el-button> -->
  <el-button   @click="inserHtml(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-tianjia"></use></svg></el-button>
     <el-button  @click="updateHtml(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
     </template>
      </el-table-column>
    </el-table>
     </el-card> 
  
     <el-dialog
    title="四级导航栏添加"
    :visible.sync="dialogVisible"
    width="30%"
    center
    >
   <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" >
      <el-form-item label="上级菜单" prop="infoMenusId">
    <el-select v-model="ruleForm.infoMenusId" placeholder="请选择上级菜单">
        <el-option :label="info.info_NAME" :value="info.info_ID" v-for="(info,index) in InfoList" :key="index"></el-option>
      </el-select>
  </el-form-item>
  <el-form-item label="名称" prop="infoFour_NAME">
      <el-input  v-model="ruleForm.infoFour_NAME" ></el-input>
    </el-form-item>
  <el-form-item label="样式类型" prop="fourType">
      <el-input  v-model="ruleForm.fourType" ></el-input>
    </el-form-item>
    <el-form-item label="顺序" prop="Four_order">
      <el-input  v-model="ruleForm.Four_order" ></el-input>
    </el-form-item>
   <el-form-item label="上传图片" prop="images">
  <el-upload
    action="https://jsonplaceholder.typicode.com/posts/"
    list-type="picture-card"
    :auto-upload="false"
    :limit="1"
     accept="image/png,image/gif,image/jpg,image/jpeg"
     ref="upload"
    :on-preview="handlePictureCardPreview"
    :on-remove="handleRemove"
     :on-change="changeFile2">
    <i class="el-icon-plus"></i>
  </el-upload>
  </el-form-item>
  </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
  <el-dialog
    title="导航栏页面添加"
    :visible.sync="showInsertHtml"
    width="50%">
  
  <el-row>
    <el-col :span="12"><div class="grid-content bg-purple">
  <el-upload
    class="upload-demo"
    drag
    action="https://jsonplaceholder.typicode.com/posts/"
    :auto-upload="false"
    :on-change="fileChange"
    :limit="1"
     ref="uploads"
    :on-remove="fileRemove"
    accept=".html,.htm">
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将html文件拖到此处，或<em>点击上传</em></div>
  </el-upload>
    </div></el-col>
    <el-col :span="12"><div class="grid-content bg-purple-light">
  
  <el-upload
    class="upload-demo"
    drag
    ref="upload"
    action="https://jsonplaceholder.typicode.com/posts/"
    :auto-upload="false"
    multiple="multiple"
    :show-file-list="false"
    :on-change="handleChanges"
    :on-remove="handleRemoves">
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将文件样式文件拖到此处，或<em>点击上传</em></div>
     <div class="el-upload__tip" slot="tip">累计上传{{fileList5.length}}个文件</div>
  </el-upload>
    </div></el-col>
  </el-row>
  
  <div class="block">
  </div>
    <span slot="footer" class="dialog-footer">
       <el-button type="primary" @click="resetResult">重 置</el-button>
      <el-button @click="showInsertHtml = false">取 消</el-button>
      <el-button type="primary" @click="subInsertHtml">提 交</el-button>
    </span>
  </el-dialog>
  
  
  
  <el-dialog
    title="四级菜单修改"
    :visible.sync="updataHtml"
    width="50%"
    destroy-on-close
    center
    >
     <el-form ref="updateHomePageRef" :model="updateHomePageForm"  :rules="rules"  label-width="80px">
    <el-form-item label="名称" prop="infoFour_NAME">
      <el-input v-model="updateHomePageForm.infoFour_NAME"></el-input>
    </el-form-item>
        <el-form-item label="上级菜单" prop="infoMenusId">
    <el-select v-model="updateHomePageForm.infoMenusId" >
      <el-option :label="info.info_NAME" :value="info.info_ID" v-for="(info,index) in InfoList" :key="index"></el-option>
      </el-select>
  </el-form-item>
  
  <el-form-item label="当前顺序" prop="Four_order">
      <el-input v-model="updateHomePageForm.Four_order"></el-input>
    </el-form-item>

    <el-form-item label="当前样式" prop="fourType">
      <el-input v-model="updateHomePageForm.fourType"></el-input>
    </el-form-item>
  
    <el-form-item label="图片" prop="imageUrl">
  <el-upload
    class="avatar-uploader"
    action="https://jsonplaceholder.typicode.com/posts/"
    :show-file-list="false"
    :auto-upload="false"
     accept="image/png,image/gif,image/jpg,image/jpeg"
      :on-change="imageHandChange"  
      :on-remove="imageHandRemoves">
    <img v-if="imageUrl" :src="imageUrl" class="avatar">
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
  
  </el-form-item>
    <el-form-item>
    </el-form-item>
  </el-form>
    <!-- 底部区域 -->
    <div style="text-align: center;">
      <el-button type="primary" @click="onUpdateSubmit">立即修改</el-button>
      <el-button @click="updataHtml = false">取 消</el-button>
      <el-button  type="" @click="resetUpdate()">重置</el-button>
    </div>
    
    
    
    </el-dialog>
  

  
    </div>
  </template>
  
  <script >
  export default {
      created(){
          this.getMenus()
      },
  data(){
      return{
        selectList:[],
        treeDate:'',
     dialogVisible:false,
     showInsertHtml:false,
     updataHtml:false,
     imageUrl:'',
     updateHtmlId:'',
      fileList5: [],
         fileList6:[],
         fileList3:[],
         fileList4:[],
     menusList:[],
      dialogImageUrl: '',
      InfoList:[],
      updateHomePageForm:{
        fourType:'',
        infoMenusId:'',
        Four_order:'',
        infoFour_NAME:'',
        infoFourId:'',
       imageUrl:'',
       oldImgUrl:'',
      },
      updateHomePageRules:{
        info_NAME:[
            { required: true, message: '请输入名称', trigger: 'change' },
               { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
         INFO_CLASSs_ID:[
            { required: true, message: '选择二级菜单', trigger: 'change' },     
        ],
       
      },
      ruleForm:{
        infoFour_NAME:'',
        infoMenusId:'',
        images:'',
        fourType:'',
        Four_order:'',
      },
      rules:{
        infoFour_NAME:[
            { required: true, message: '请输入名称', trigger: 'blur' },
               { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        infoMenusId:[
            { required: true, message: '请选择二级菜单名称',  trigger: 'change' },
            
        ],images:[{ required: true, message: '请上传图片',  trigger:'change' },],
        fourType:[{ required: true, message: '请填入样式',  trigger:'change' },],
        Four_order:[{ required: true, message: '请填入顺序',  trigger:'change' },],
      }
      }
  },
  methods:{
    getMenus(){
      this.axios.post("/info/getMenusById?isFourMenus=0")
                   .then(resp => { 
                        if(resp.data.status == 1) {    
                         console.log(resp.data.result)                                           
                                 this.InfoList=resp.data.result 
                                 console.log(this.InfoList)                                                        
                                  }else {
                                      alert("失败")
                                     this.$message.error(resp.result.message)                               
                                  }
                              })
                              .catch((err) => {
                                 // alert("出错了")
                                  console.log(err)
                              }) 
  this.axios.post("/info/getInfoFour")
            .then(resp => { 
                        if(resp.data.status == 1) {    
                           this.menusList=resp.data.result  
                           console.log( this.menusList)                                                            
                                  }else {
                                      alert("失败")
                                     this.$message.error(resp.result.message)                               
                                  }
                              })
                              .catch((err) => {
                                  console.log(err)
                              })},
                              deleteMenus(data){
                                const that=this
          this.$confirm("确定删除？","提示",{
            confirmButtonText: "确认",//确认按钮文字更换
            cancelButtonText: "取消",//取消按钮文字更换
            showClose: true,//是否显示右上角关闭按钮
            type: "warning",//提示类型  success/info/warning/error
        }).then(function(){  
          that.axios.post("/info/deleteInfoFour","infoFourId="+data.infoFourId)
            .then(resp => { 
                        if(resp.data.status == 1) {    
                          that.$message.success("删除成功")  
                          that.getMenus()                                                   
                                  }else {
                                      alert("失败")
                                      that.$message.error(resp.result.message)                               
                                  }
                              })
                              .catch((err) => {
                                alert("失败")
                                  console.log(err)
                              }) 
        }).catch(()=>{});
       },
                             updateHtml(data){
                              console.log(data)
                              this.updataHtml=true
                              // this.updateHtmlId=data.info_ID
                              // this.updateHomePageForm.info_ID=data.info_ID
                              this.showNavigation('2')
                               this.imageUrl=this.$imagepath+data.filePath
                               this.updateHomePageForm.oldImgUrl=data.filePath
                               this.updateHomePageForm.infoMenusId=data.infoMenusId    
                               this.updateHomePageForm.infoFourId=data.infoFourId    
                               this.updateHomePageForm.infoFour_NAME=data.infoFour_NAME  
                               this.updateHomePageForm.Four_order=data.four_order                                           
                               this.updateHomePageForm.fourType=data.fourType
                            
                      
  
  
                              },
      showNavigation(data){
        if(data==1){
           this.dialogVisible=true
        }
        
      }, 
       
      submitForm(ruleForm){
         this.$refs[ruleForm].validate(
          (valid)=>{
           if (!valid)
            return 
          let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
             this.axios.post("/info/insertInfoFour",this.ruleForm,config)
            .then(resp => { 
                        if(resp.data.status == 1) {    
                          this.$message.success("添加成功")
                                     this.dialogVisible=false
                                      this.getMenus()    
                                 this.$refs.upload.clearFiles()
                                  }else {
                                      alert("失败")
                                     this.$message.error(resp.result.message)                               
                                  }
                              })
                              .catch((err) => {
                                 // alert("出错了")
                                  console.log(err)
                              }) 
      })}, getFourNav(){
        if(this.selectList.length<=0){
            this.selectList=this.menusList
          }
          this.menusList=this.selectList
        this.menusList=this.menusList.filter((item)=>{
            if(this.treeDate!=''){
              return  this.treeDate==item.infoMenusId
           }else{
            return true
           }
          })
      },
      onUpdateSubmit(){
          this.$refs.updateHomePageRef.validate((valid)=>{
           if (!valid)
           return
      let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
             this.axios.post("/info/updateInfoFour",this.updateHomePageForm,config)
              .then(resp => { 
                        if(resp.data.status == 1) {    
                          this.$message.success("修改成功")
                                     this.updataHtml=false
                                      this.getMenus()    
                                 this.$refs.updateHomePageRef.resetFields()
                                  }else {
                                      alert("失败")
                                     this.$message.error(resp.result.message)                               
                                  }
                              })
                              .catch((err) => {
                                  alert("出错了")
                                  console.log(err)
                              }) 
   }
       
  
           
          )
      },
       handleRemove(file, fileList) {
        this.ruleForm.images=''
          console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
          changeFile2(file, fileList) {
          this.ruleForm.images = fileList[0].raw
            },
            inserHtml(data){
          this.insertid=data.infoFourId
            this.showInsertHtml=true;
        },
              imageHandChange(file, fileList) {
          this.imageUrl = URL.createObjectURL(file.raw);
          this.updateHomePageForm.imageUrl=file.raw
        },
        imageHandRemoves(file, fileList) {
         this.updateHomePageForm.imageUrl=''
        },
        handleChanges(file, fileList) {
        this.fileList5=fileList
        },handleRemoves(file, fileList) {
          this.fileList5=fileList
        },fileChange(file, fileList){
          this.fileList3=fileList
        },fileRemove(file, fileList){
          this.fileList3=fileList
        },   resetResult(){
           this.fileList5=[]
                                    this.fileList6=[]
                                    this.fileList3=[]
                                    this.fileList4=[]
                                    this.$refs.upload.clearFiles()
                                    this.$refs.uploads.clearFiles()
        }  , 
        resetUpdate(){
      this.$refs.updateHomePageRef.resetFields()
  
        },
        
        subInsertHtml(){
           if(this.fileList5.length <= 0 ||this.fileList3.length==0 ){
             this.$message.error("请选择上传文件") 
           return false}
  
  
  
      for(var i=0;i<this.fileList5.length;i++){
       this.fileList6.push(this.fileList5[i].raw)
      }
      this.fileList4=this.fileList3[0].raw
       let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
        const fd = new FormData();
         this.fileList6.forEach((file) => {
           fd.append("style", file);
        });
        fd.append("infoLClassID",this.insertid)
        fd.append("file",this.fileList4)
          this.axios.post("/info/insertHtmlFourMenus",fd,config)
           .then(resp => { 
                         if(resp.data.status == 1) {
                                    this.$message.success("添加成功")
                                    this.fileList5=[]
                                    this.fileList6=[]
                                    this.fileList3=[]
                                    this.fileList4=[]
                                    this.$refs.upload.clearFiles()
                                    this.$refs.uploads.clearFiles()
                                     this.showInsertHtml=false    
                                     this.getMenus()  
                                  }else {
                                    this.$message.error(resp.data.message)
                                    this.fileList6=[],
                                    this.fileList4=[],
                                         alert("出错")    
                                          this.$message.error(resp.result.message)                           
                                  }
                              })
                              .catch((err) => {
                                  alert("出错了")
                                  console.log(err)
                              }) 
    
        }
            
     
      }
  }
  
  </script>
  
  <style scoped>
  .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
   .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
     .lableforSearch{
      margin-top:8px;
      color:grey
}
  </style>


// WEBPACK FOOTER //
// src/components/work/navigation/majorsetup/FourNavigation.vue